import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { formatMoney, moneyOrZero } from "@faire/web--source/common/money";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import flashSaleflashSaleToken from "@faire/web-api--source/routes/flash-sale/flashSaleToken";
import React from "react";
import styled from "styled-components";
import { NoTranslate } from "@faire/retailer/components/NoTranslate";
import { SERRANO } from "@faire/retailer-visitor-shared/consts/colors";
import { useSettingDealsHub } from "@faire/retailer/settings/useSettingDealsHub";
import { useGetSettingAndAssignUpdateSaleColorCopy } from "@faire/retailer/settings/useSettingUpdateSaleColorCopy";
import { FlashSaleImageGridV2 } from "./FlashSaleImageGridV2";
export var FlashSaleBundleTile = function(props) {
    var _props_item = props.item, token = _props_item.token, image = _props_item.image, product_images = _props_item.product_images, discount_percentage = _props_item.discount_percentage, price = _props_item.price, original_price = _props_item.original_price, brand_name = _props_item.brand_name;
    var isFlashDealsRevamp = useSettingDealsHub();
    var shouldUpdateAndAssignSaleColor = useGetSettingAndAssignUpdateSaleColorCopy();
    return /*#__PURE__*/ _jsxs(Wrapper, {
        onClick: function() {
            var _props_onClick;
            (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, token !== null && token !== void 0 ? token : "");
        },
        "data-test-id": "flash-sale-bundle-tile",
        to: flashSaleflashSaleToken(token !== null && token !== void 0 ? token : ""),
        style: {
            border: isFlashDealsRevamp ? "none" : "1px solid ".concat(Core.border.muted)
        },
        children: [
            /*#__PURE__*/ _jsx(FlashSaleImageGridV2, {
                images: product_images
            }),
            /*#__PURE__*/ _jsxs(Content, {
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        size: "small",
                        image: image
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(Row, {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraphSansMedium",
                                    maxLines: 1,
                                    children: /*#__PURE__*/ _jsx(NoTranslate, {
                                        children: brand_name
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs(PriceInfoContainer, {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        color: shouldUpdateAndAssignSaleColor ? SERRANO : Decorative.shade.orange,
                                        children: formatMoney({
                                            money: moneyOrZero(price)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: 4
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        color: Core.text.subdued,
                                        strikethrough: true,
                                        children: formatMoney({
                                            money: moneyOrZero(original_price)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: 4
                                    }),
                                    discount_percentage ? /*#__PURE__*/ _jsx(Typography, {
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "InegfC",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "("
                                                },
                                                {
                                                    type: 1,
                                                    value: "discountPercentageNumber"
                                                },
                                                {
                                                    type: 0,
                                                    value: "% off)"
                                                }
                                            ],
                                            values: {
                                                discountPercentageNumber: discount_percentage
                                            }
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Wrapper = styled(Link).withConfig({
    componentId: "sc-2a1fc790-0"
})([
    "display:flex;flex-direction:column;overflow:hidden;height:100%;background-color:",
    ";"
], Core.surface.inverse);
var Content = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-2a1fc790-1"
})([
    "padding:",
    ";"
], getSpacing("2x"));
var PriceInfoContainer = styled(Row).withConfig({
    componentId: "sc-2a1fc790-2"
})([
    "flex-wrap:wrap;"
]);
